import { render, staticRenderFns } from "./Task3.vue?vue&type=template&id=db249326&scoped=true&"
import script from "./Task3.vue?vue&type=script&lang=js&"
export * from "./Task3.vue?vue&type=script&lang=js&"
import style0 from "./Task3.vue?vue&type=style&index=0&id=db249326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db249326",
  null
  
)

export default component.exports